/* − / + ajustam o input e submetem o form do carrinho.
   sem o JS a pagina continua utilizavel: o input e editavel e ha botao de atualizar */
(function(){
  var form = document.getElementById('cw-cart-form');
  if (!form) return;
  form.addEventListener('click', function(e){
    var b = e.target.closest('.cw-step');
    if (!b) return;
    e.preventDefault();
    var input = document.getElementById(b.dataset.target);
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, Math.min(99, v + (b.dataset.step === '-' ? -1 : 1)));
    form.submit();
  });
})();

/* a pagina de carrinho virou passagem: o cliente nao edita nada, ela conserta o
   ebook e encaminha para o checkout.
   so nao encaminha quando o ebook ficaria sozinho — carrinho so com o brinde
   fecharia um pedido de $0, entao ele e removido e a pagina fica vazia.
   esconde o conteudo antes do fetch para nao piscar um carrinho editavel, e
   devolve a visibilidade em todo caminho que nao redireciona, inclusive no erro. */
(function(){
  var EBOOK = 54677877686547;
  if (!document.getElementById('cw-cart-form')) return;

  var main = document.querySelector('.cw-wrap');
  if (main) main.style.visibility = 'hidden';
  function stay(){ if (main) main.style.visibility = ''; }

  fetch('/cart.js', {headers: {'Accept': 'application/json'}})
    .then(function(r){ return r.json(); })
    .then(function(cart){
      var qty = 0, real = false;
      cart.items.forEach(function(i){
        if (i.variant_id === EBOOK) { qty = i.quantity; } else { real = true; }
      });

      if (!real) {
        if (qty > 0) return set(0).then(function(){ location.reload(); });
        return stay();
      }
      if (qty !== 1) return set(1).then(go);
      return go();
    })
    .catch(stay);

  function go(){ location.replace('/checkout'); }

  function set(q){
    var updates = {};
    updates[EBOOK] = q;
    return fetch('/cart/update.js', {
      method:  'POST',
      headers: {'Content-Type': 'application/json'},
      body:    JSON.stringify({updates: updates})
    });
  }
})();
